angular.module("digitalLeasing.module").component("financialData", {
  templateUrl: "ng/components/digitalLeasing/financialData/financialData.view.html",
  bindings: {
    model: "=",
    validatePage: '&',
    invalidatePage: '&',
    snapshot: '<'
  },
  controllerAs: "FinancialDataCtrl",
  controller: FinancialDataController
});

function FinancialDataController(
  $financialApiService,
  $timeout,
  $storageService
) {
  var self = this;

  self.$onInit = function () {
    self.checkAdditionaConfiguration = true;
    //self.callCalcola = false;
    self.listOfEstimates = [];
    self.insuranceChanged = [];


    if (!self.snapshot) {
      if ($storageService.getAppConfig().user.reteVendita == 5) {
        closeAccordion();
      }
      getCondizioniAggiuntive();
    }

  };

  var handlechange = function (property, value) {

  };

  self.handleStructureChange = function (financialData) {
    handlechange("financialData", financialData);
  };

  self.updateList = function (response) {
    self.listOfEstimates = [];
    self.listOfEstimates = response.pianoFinanziario.spese;
    self.tassoPrelocazione = response.pianoFinanziario.tassiCalcolati.tassoPrelocazione;
    self.validations = response.validations
  }

  self.upgradeTotalEstimate = function (totalEstimates) {
    self.model.leasingData.preventivo.pianoFinanziario.provvigioni.speseRiconosciute = totalEstimates;
  }

  self.handleIndexingChange = function (tassi) {
    self.tassi = tassi;
  }

  self.responseCalcolaCanoneTasso = function (response) {
    if (response && !response.success) {
      self.erroreCalcolaCanoneTasso = true;
    } else {
      self.erroreCalcolaCanoneTasso = false;
      self.provvigioni = response && response.provvigioni;
    }
    self.canoneTassoCalled = !self.canoneTassoCalled;
    self.checkPage();
  }

  self.importOk = function () {
    self.importoOK = true;
    self.checkPage();
  }

  self.importNotOk = function () {
    self.importoOK = false;
    self.checkPage();
  }

  self.exportDurata = function (value) {
    self.durata = value;
  }

  self.tassoFixChanged = function () {
    self.callEconomicConditionDetail = !self.callEconomicConditionDetail;
  }

  self.endInfoTassi = function () {
    self.callEconomicConditionDetail = !self.callEconomicConditionDetail;
  }

  self.callCalcolaCanoneFunc = function (value) {
    self.callCalcola = !self.callCalcola;
    self.forceCallCalcola = value;
    self.checkPage();
  }

  self.checkRateAndFee = function (value) {
    self.valueOfRateAndFee = value;
    self.checkPage();
  }

  self.checkIndexing = function (value) {
    self.valueOfIndexing = value;
    self.checkPage();
  }

  self.checkInsurance = function (value) {
    self.valueOfInsurance = value
    self.checkPage();
  }

  self.checkQuoteNotes = function (value) {
    self.valueOfQuoteNote = value;
    self.checkPage();
  }

  self.callCheckQuote = function (value) {
    self.valueForCallCheckQuote = value;
  }

  self.handleInsuranceChange = function (value) {
    self.checkEstimatesValue = !self.checkEstimatesValue;
    self.insuranceChanged = value.leasingData.preventivo.assicurazioni;
  }

  self.checkEstimatesInsuranceChangedFn = function () {
    self.checkEstimatesValueBis = !self.checkEstimatesValueBis;
  }

  self.checkEstimatesFunc = function () {
    self.checkEstimatesValue = !self.checkEstimatesValue;
  }

  self.callGetInsuranceFunc = function () {
    self.callGetInsurance = !self.callGetInsurance;
  }

  self.checkEstimantesFunc = function (value) {

    self.checkEstimates = value;
    self.checkPage();

  }

  self.validateCommission = function (value) {
    self.checkCommission = value;
    self.checkPage();
  }



  self.checkPage = function () {

    var test = !self.erroreCalcolaCanoneTasso &&
      self.importoOK &&
      self.valueOfRateAndFee &&
      self.valueOfIndexing &&
      self.valueOfInsurance &&
      self.valueOfQuoteNote &&
      self.checkEstimates &&
      !self.checkCommission &&
      self.checkAdditionaConfiguration

    if (test) {
      self.validatePage();
    } else {
      self.invalidatePage();
    }


  }
  var getCondizioniAggiuntive = function () {
    var prodotto = self.model.leasingData.preventivo.prodotto
    var ndgVenditore = self.model.financialVendor.riUserG.ndg

    $financialApiService.getCondizioniAggiuntive(prodotto.id, ndgVenditore)
      .then(function (response) {
        self.listOfAdditionalCondition = response;
      })
  }

  self.validateAdditionalConfiguration = function () {
    self.checkAdditionaConfiguration = true;
    self.checkPage();
  }

  self.invalidateAdditionalConfiguration = function () {
    self.checkAdditionaConfiguration = false;
    self.checkPage();
  }

  var closeAccordion = function () {
    $timeout(function () {
      $("#collapseContainerinsuranceId").collapse("hide");
      $("#collapseContainerindexingId").collapse("hide");
      $("#collapseContainercommissionsId").collapse("hide");
    }, 1000)

  }

  self.calcCanoneTassoRunning = function (value) {
    self.canoneTassoRun = value;
  }

  self.canoneModifyEnabled = function (value) {
    self.enabledCanoneFromProvvigioni = value;
  }

}